var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBigPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(-51 -720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_11",
    "data-name": "Union 11",
    d: "M7.112,15.11V8.888H.89a.888.888,0,1,1,0-1.777H7.112V.889a.888.888,0,1,1,1.777,0V7.111H15.11a.888.888,0,1,1,0,1.777H8.888V15.11a.888.888,0,1,1-1.777,0Z",
    transform: "translate(51 720)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BigPlus.47b062020625ef74b853420d55591ce6.svg";